import Model from './Model'

export default class ProgramCategory extends Model {
  resource() {
    return 'program/categories'
  }
}
